import React from 'react'
import { Updater, async, fromJSX, nothing, Widget, any } from 'widgets-for-react'
import { InviewProps, SVGIconProps } from '../blocksState'
import { AllCourseCategoriesBlockLayout } from './allCourseCategoriesBlockLayout'
import {
  AllCourseCategories,
  AllCourseCategoriesBlockState
} from './allCourseCategoriesBlockState'

export type AllCourseCategoriesBlock = {
  index: number
  inview?: InviewProps
  title?: React.ReactNode
  courseCategoriesState: AllCourseCategoriesBlockState
  SVGIcon?: SVGIconProps
}

export const allCourseCategoriesBlockWidget = (
  block: AllCourseCategoriesBlock
): Widget<Updater<AllCourseCategoriesBlockState>> => {
  const categories = block.courseCategoriesState.allCourseCategoriesState
  return any<Updater<AllCourseCategoriesBlockState>>([
    categories.kind == 'loaded'
      ? fromJSX(setState => (
          <AllCourseCategoriesBlockLayout
            {...block}
            children={categories.value}
            query={block.courseCategoriesState.query}
            setQuery={(newQuery: string) =>
              setState(s => ({ ...s, query: newQuery }))
            }
          />
        ))
      : nothing(),
    async<AllCourseCategories>(
      block.courseCategoriesState.allCourseCategoriesState
    ).map(updater => s => ({
      ...s,
      allCourseCategoriesState: updater(s.allCourseCategoriesState)
    }))
  ])
}
